import React from "react";
import Switch from "./Switch";

interface IProps {
    className?: string;
    value: boolean;
    label?: string;
    switch?: (onOff: boolean) => void;
    tabIndex?: number;
}

function CustomCheckBox(props: IProps) {
    return (
        <div
            className={`customSwitch ${props.className} ? ${props.className} : ""`}
            tabIndex={props.tabIndex}
            // style={{border: "1px solid red"}}
        >
            <label>{props.label}</label>
            <Switch className={"switch"} value={props.value} switch={() => props.switch(!props.value)}/>
            <div className="border"/>
        </div>
    );
}
export default(CustomCheckBox);
